import { assert, assertNonNullable } from 'cadenza/utils/custom-error';

export class SingleTaskWebWorkerApi {

  readonly #worker: Worker;
  #used: boolean = false;
  #resolve: ((value: unknown) => void) | undefined;
  #reject: ((value: unknown) => void) | undefined;

  constructor (worker: Worker) {
    assertNonNullable(worker, 'The worker must not be null.');
    this.#worker = worker;

    worker.addEventListener('message', (event) => {
      const resolve = this.#resolve;
      assertNonNullable(resolve, 'The worker is sending a message before the task was submitted.');
      resolve(event.data);
    });

    worker.addEventListener('error', (error: ErrorEvent) => {
      const reject = this.#reject;
      assertNonNullable(reject, 'The worker is sending an error before the task was submitted.');
      reject(error);
    });
  }

  terminateImmediate () {
    this.#worker.terminate();
  }

  protected execute (payload: unknown) {
    assert(!this.#used, 'Worker is/was already in use.');
    return new Promise((resolve, reject) => {
      this.#used = true;
      this.#resolve = resolve;
      this.#reject = reject;
      this.#worker.postMessage(payload);
    }).finally(() => this.#worker.terminate());
  }

}
